import { render } from "./BlockSummary.vue?vue&type=template&id=75ca4c55"
import script from "./BlockSummary.vue?vue&type=script&lang=js"
export * from "./BlockSummary.vue?vue&type=script&lang=js"
script.render = render

export default script